<template>
	<div id="app">
		<div id="header">
			<div class="logo_search_wrap">
				<div class="logo_serve">
					<div class="logo">
						<img src="./assets/img/logo.png"/>
					</div>
				</div>
			</div>
			<div class="nav_wrap">
				<div class="nav_item">
					<router-link to='/'>首页</router-link>
					<router-link to='/about'>关于我们</router-link>
					<router-link to='/car'>汽车金融 </router-link>
					<router-link to='/recruit'>合伙人招募</router-link>
					<router-link to='/join'>加入我们</router-link>
					<router-link to='/contact'>联系我们</router-link>
				</div>
			</div>
		</div>
		<router-view></router-view>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				loginFun(){
					this.$router.push({
						path:'/login'
					})
				}
			}
		},
		mounted(){

		},
		methods:{

		}
	}
</script>

<style lang="scss">
	body{
		background:#F1F1F1;
	}
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: left;
		color: #333;
		background:#F1F1F1;
		padding-top:136px;
		#header{
			width:100%;
			height:136px;
			position:fixed;
			left:0;
			top:0;
			z-index:9999;
			.logo_search_wrap{
				background:#fff;
				.logo_serve{
					width:1200px;
					height:60px;
					height:60px;
					padding:19px 0;
					margin:0 auto;
				}
				.logo{
					width:156px;
					height:60px;
					float:left;
					img{
						display: block;
						width:156px;
					}
				}
				.search{
					width:170px;
					height:38px;
					border:1px solid #A8ADB3;
					border-radius: 19px;
					padding:0 40px 0 20px;
					position:relative;
					margin-top:10px;
					float:right;
					input{
						display: block;
						width:170px;
						height:38px;
						border:none;
						outline: none;
					}
					i{
						display: block;
						width:20px;
						height:20px;
						background:url(assets/img/search.png) no-repeat;
						background-size:100%;
						position:absolute;
						right:13px;
						top:9px;
					}
				}
				.login{
					line-height:60px;
					float:right;
					margin-left:50px;
					font-size:18px;
					color:#4848FF;
					cursor: pointer;
				}
			}
			.nav_wrap{
				height:38px;
				background:#1262B2;
				.nav_item{
					width:1025px;
					height:38px;
					margin:0 auto;
					a{
						display: block;
						width:168px;
						height:38px;
						text-align: center;
						line-height: 38px;
						float:left;
						font-size:18px;
						color:#FFFFFF;
						border-right: 1px solid #fff;
					}
					a:nth-last-of-type(1){
						border:none;
					}
					.router-link-exact-active{
						background:#DD4E52;
					}
				}
			}
		}
	}
</style>